import type { MRT_Row, MRT_TableInstance } from "mantine-react-table-open";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";

interface UpdateColumnParams {
  table: MRT_TableInstance<FictionalEnergyValueResponse>;
  row: MRT_Row<FictionalEnergyValueResponse>;
  columnIds: Array<keyof FictionalEnergyValueResponse>;
  newValues: Array<string | number | null>;
}

function updateRowData({
  table,
  row,
  columnIds,
  newValues
}: UpdateColumnParams): void {
  const creationRow = table.getState().creatingRow;
  if (creationRow && creationRow.id === row.id) {
    table.setCreatingRow({
      ...creationRow,
      _valuesCache: {
        ...creationRow._valuesCache,
        ...columnIds.reduce(
          (acc, columnId, index) => {
            acc[columnId] = newValues[index];
            return acc;
          },
          {} as Record<
            keyof FictionalEnergyValueResponse,
            string | number | null
          >
        )
      }
    });
  }

  const editingRow = table.getState().editingRow;
  if (editingRow && editingRow.id === row.id) {
    table.setEditingRow({
      ...editingRow,
      _valuesCache: {
        ...editingRow._valuesCache,
        ...columnIds.reduce(
          (acc, columnId, index) => {
            acc[columnId] = newValues[index];
            return acc;
          },
          {} as Record<
            keyof FictionalEnergyValueResponse,
            string | number | null
          >
        )
      }
    });
  }
}

export { updateRowData };
